import script from "./SideBarPublishingPanelComment.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarPublishingPanelComment.vue?vue&type=script&setup=true&lang=js"

import "./SideBarPublishingPanelComment.vue?vue&type=style&index=0&id=baf28d26&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baf28d26"]])

export default __exports__